import styled from 'styled-components';

// Mesmo cabeçalho da página do grupo (VirtualGroupPage): seta na cor do tenant
export const Wrapper = styled.div`
  margin: 0 auto;

  .ant-page-header-back-button:focus,
  .ant-page-header-back-button:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

export const Title = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 16px;
`;

export const Content = styled.div`
  margin: 0 24px 24px;

  @media (max-width: 576px) {
    margin: 0 8px 16px;
  }
`;
